<script>
import {
  pageFicheMagasinEmits,
  pageFicheMagasinProps,
  usePageFicheMagasin
} from "./mixin";
import Titre from "@/components/atoms/titre";
import IconShipping from "@/components/molecules/icon-shipping";
import Button from "@/components/atoms/button";
import Map from "@/components/molecules/map";
import Divider from "@/components/atoms/divider";
import ButtonIcon from "@/components/molecules/button-icon";
import ContainerHeading from "@/containers/container-heading";
import Prospectus from "@/components/molecules/prospectus";
import PrixCarburant from "@/components/molecules/prix-carburant";
import Icon from "@/components/atoms/icon";
import Popin from "@/components/molecules/popin";
import LinkTo from "@/components/atoms/link-to";
import WithdrawalPoint from "@/components/organisms/withdrawal-point";
import { useFicheMagasinStructuredData } from "@/mixins/seo/ficheMagasinStructuredData";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import PopinClickAndCollect from "@/components/organisms/popin-click-collect";
import PopinTraiteurDeFetes from "@/containers/popin-traiteur-de-fetes";
import PopinTraiteurPermanent from "@/containers/popin-traiteur-permanent";
import PopinClickCollectTraiteurFetes from "@/components/organisms/popin-cc-traiteur-fetes";
import PopinClickCollectTraiteurPermanent from "@/components/organisms/popin-cc-traiteur-permanent";
import TemplateMagasin from "@/components/organisms/template-page-magasin/mobile";
import MeaCoraproMagasin from "@/containers/mise-en-avant-corapro";
import footerCodes from "@/utils/footer-codes";

import illustrationAnanasPastequePain from "@/assets/images/illustration-ananas-pasteque-pain.svg";
import fruits from "@/assets/images/fruits.svg";

export default {
  name: "FicheMagasinMobile",
  components: {
    Titre,
    IconShipping,
    Button,
    Map,
    Divider,
    ButtonIcon,
    ContainerHeading,
    Prospectus,
    PrixCarburant,
    Icon,
    Popin,
    LinkTo,
    WithdrawalPoint,
    HtmlParser,
    GridCol,
    GridRow,
    PopinClickAndCollect,
    PopinTraiteurDeFetes,
    PopinTraiteurPermanent,
    PopinClickCollectTraiteurFetes,
    PopinClickCollectTraiteurPermanent,
    TemplateMagasin,
    MeaCoraproMagasin
  },
  emits: ["openOrcloseStoreLocator", ...pageFicheMagasinEmits()],
  data() {
    return {
      footerCodes
    };
  },
  props: {
    ...pageFicheMagasinProps()
  },
  setup(props, context) {
    const traiteurFete = ref(null);
    const traiteurPermanent = ref(null);
    const {
      maxServices,
      showWithdrawalPoints,
      withdrawalPoints,
      showPlanningClickCollect,
      showPlanningClickCollectTraiteur,
      showPlanningClickCollectTraiteurNoel,
      isNational,
      itineraire,
      exceptionalOpening,
      exceptionalClosure,
      shopTimetable,
      positions,
      modesDeCommande,
      changeShop,
      toggleWithdrawalPoints,
      togglePlanningTabClickCollect,
      togglePlanningTabClickCollectTraiteur,
      togglePlanningTabClickCollectTraiteurNoel,
      closeWithdrawalPopin,
      displayAllServices,
      getPushData,
      getPushList,
      getPushTitle,
      mounted,
      ShopPageCodes,
      isFuelAvailable
    } = usePageFicheMagasin(props, context, traiteurFete, traiteurPermanent);

    const { head } = useFicheMagasinStructuredData(props.magasin);
    useHead(head);

    onMounted(mounted);

    return {
      isFuelAvailable,
      maxServices,
      showWithdrawalPoints,
      withdrawalPoints,
      showPlanningClickCollect,
      showPlanningClickCollectTraiteur,
      showPlanningClickCollectTraiteurNoel,
      isNational,
      itineraire,
      exceptionalOpening,
      exceptionalClosure,
      shopTimetable,
      positions,
      modesDeCommande,
      changeShop,
      toggleWithdrawalPoints,
      togglePlanningTabClickCollect,
      togglePlanningTabClickCollectTraiteur,
      togglePlanningTabClickCollectTraiteurNoel,
      closeWithdrawalPopin,
      displayAllServices,
      getPushData,
      getPushList,
      getPushTitle,
      ShopPageCodes,
      traiteurFete,
      traiteurPermanent,
      illustrationAnanasPastequePain,
      fruits
    };
  }
};
</script>

<template>
  <div>
    <PopinClickCollectTraiteurFetes
      ref="traiteurFete"
      slide-up
      :magasin="magasin"
    />
    <PopinClickCollectTraiteurPermanent
      ref="traiteurPermanent"
      slide-up
      :magasin="magasin"
    />
    <PopinClickAndCollect
      slide-up
      :show-planning-click-collect="showPlanningClickCollect"
      :magasin="magasin"
      @closed="showPlanningClickCollect = false"
    />
    <PopinTraiteurDeFetes
      slide-up
      :show-planning-click-collect-traiteur="showPlanningClickCollectTraiteurNoel"
      @closed="showPlanningClickCollectTraiteurNoel = false"
    />
    <PopinTraiteurPermanent
      slide-up
      :visible="showPlanningClickCollectTraiteur"
      @closed="showPlanningClickCollectTraiteur = false"
    />
    <Popin
      ref="horaires"
      aria-label="Horaires"
      slide-up
    >
      <Titre
        tag="h2"
        variant="primary"
        class="u-mb-md"
        size="xs"
      >
        Horaires <br />
        Magasin {{ magasin.attributes.magasin }}
      </Titre>
      <div v-if="shopTimetable && shopTimetable.timetable && shopTimetable.timetable.length > 0">
        <template
          v-for="(item, index) in shopTimetable.timetable"
          :key="`timetable-${index}`"
        >
          <div
            v-if="item.jour"
            class="u-flex u-flex-justify-between u-flex-align-center"
          >
            <p>{{ item.jour }}</p>
            <p v-if="item.from == '00:00' && item.to == '00:00'">
              Fermé
            </p>
            <p v-else-if="item.from && item.to">
              {{ item.from }} - {{ item.to }}
            </p>
            <p v-else-if="item.from">
              {{ item.from }}
            </p>
            <p v-else-if="item.to">
              {{ item.to }}
            </p>
          </div>
          <Divider
            v-if="index < shopTimetable.timetable.length - 1"
            :key="'divider' + index"
            class="u-mt-sm u-mb-sm"
          />
        </template>
      </div>
    </Popin>

    <Popin
      ref="infos"
      page-back
      aria-label="Informations pratiques et services du magasin"
      page-back-label="Retour à la fiche magasin"
    >
      <div class="u-pl-md u-pr-md">
        <Titre
          tag="h2"
          variant="primary"
          class="u-mb-md u-text-center"
          size="xs"
        >
          Informations pratiques et services du magasin
          {{ magasin.attributes.magasin }}
        </Titre>
        <Divider dotted />
        <p
          v-if="magasin.attributes.telephone_magasin"
          class="u-font-15"
        >
          <strong class="u-font-500">Contactez votre magasin</strong>
        </p>
        <div
          v-if="magasin.attributes.telephone_magasin"
          class="u-flex u-flex-align-center"
        >
          <Icon name="phone" />
          <p
            class="u-ml-sm u-font-15"
            itemprop="telephone"
          >
            {{ magasin.attributes.telephone_magasin }}
          </p>
        </div>
        <div class="u-flex u-flex-align-center">
          <Icon name="email-fast" />
          <LinkTo
            class="u-ml-sm u-font-15"
            itemprop="email"
            variant="primary"
            to="/infos-et-services/aide/contactez-nous"
          >
            Contactez-nous
          </LinkTo>
        </div>
        <Divider dotted />
        <template v-if="magasin.attributes.services && magasin.attributes.services.length > 0">
          <p class="u-font-15 u-mb-xs">
            <strong class="u-font-500">Les services en magasin</strong>
          </p>
          <template
            v-for="(service, index) in magasin.attributes.services"
            :key="service.libelle"
          >
            <p
              v-if="index < maxServices"
              class="u-font-15 u-mb-xs"
            >
              {{ service.libelle }}
            </p>
          </template>
          <ButtonIcon
            v-if="magasin.attributes.services.length > 2"
            :icon-name="
              maxServices == magasin.attributes.services.length
                ? 'arrow-up'
                : 'arrow-down'
            "
            link
            icon-size="sm"
            variant="text"
            @click="displayAllServices"
          >
            Voir
            <template v-if="maxServices === 2">
              tous les services
            </template>
            <template v-else>
              moins de services
            </template>
          </ButtonIcon>
          <Divider
            dotted
            class="u-mt-sm u-mb-sm"
          />
        </template>
        <div
          v-if="magasin.attributes.twitter || magasin.attributes.facebook"
          class="u-flex u-flex-align-center u-flex-wrap u-mt-md"
        >
          <p class="u-font-15 u-color-text-light u-mr-xs">
            Suivez-nous :
          </p>
          <ButtonIcon
            v-if="magasin.attributes.twitter"
            icon-name="social-twitter-circle"
            icon-size="sm"
            icon-color="primary"
            aria-label="Lien vers le compte Twitter Cora"
            class="u-mr-xs"
            :href="magasin.attributes.twitter"
            target="__blanc"
          />
          <ButtonIcon
            v-if="magasin.attributes.facebook"
            icon-name="social-facebook-circle"
            icon-size="sm"
            icon-color="primary"
            aria-label="Lien vers la page Facebook Cora."
            class="u-mr-xs"
            :href="magasin.attributes.facebook"
            target="__blanc"
          />
          <ButtonIcon
            v-if="magasin.attributes.youtube"
            icon-name="social-youtube-circle"
            icon-size="sm"
            icon-color="primary"
            aria-label="Lien vers la page youtube Cora."
            class="u-mr-xs"
            :href="magasin.attributes.youtube"
            target="__blanc"
          />
          <ButtonIcon
            icon-name="social-linkedin-circle"
            icon-color="primary"
            icon-size="sm"
            class="u-mr-xs"
            aria-label="Lien vers le compte linkedin Cora."
            :href="footerCodes.LINKEDIN"
            target="__blanc"
          />
          <ButtonIcon
            icon-name="social-tiktok-circle"
            icon-color="primary"
            icon-size="sm"
            aria-label="Lien vers le compte tiktok Cora."
            class="u-mr-xs"
            :href="footerCodes.TIKTOK"
            target="__blanc"
          />
          <ButtonIcon
            icon-name="social-pinterest-circle"
            icon-color="primary"
            icon-size="sm"
            aria-label="Lien vers le compte pinterest Cora."
            class="u-mr-xs"
            :href="footerCodes.PINTEREST"
            target="__blanc"
          />
        </div>
      </div>
    </Popin>
    <Popin
      :visible="showWithdrawalPoints"
      aria-label="Liste des points retrait"
      slide-up
      @closed="closeWithdrawalPopin()"
    >
      <Titre
        tag="h2"
        variant="primary"
        class="u-mb-md u-text-center"
        size="xs"
      >
        Liste des points retrait
      </Titre>
      <WithdrawalPoint :withdrawal-points="withdrawalPoints" />
    </Popin>
    <Popin
      ref="modesLivraison"
      aria-label="Modes de livraison disponibles dans le magasin"
      page-back
      page-back-label="Retour à la fiche magasin"
    >
      <div class="u-pl-md u-pr-md">
        <Titre
          tag="h2"
          size="xs"
          variant="primary"
          class="u-text-center"
        >
          Modes de livraison disponibles dans le magasin
          {{ magasin.attributes.magasin }}
        </Titre>
        <Divider
          dotted
          class="u-mb-sm u-mt-sm"
        />
        <div
          v-for="mdc in modesDeCommande"
          :key="mdc.type"
          :class="
            mdc.type === 'CC_TRAITEUR_NOEL' || mdc.type === 'CC_TRAITEUR_PERMANENT'
              ? 'u-flex u-flex-align-start u-mb-sm'
              : 'u-flex u-flex-align-center u-mb-sm'
          "
        >
          <IconShipping
            :type="mdc.type"
            variant="primary"
          />
          <div class="u-ml-sm">
            <p class="u-font-13">
              {{ mdc.label_long }}
            </p>
            <Button
              v-if="
                mdc.type === 'PRP' || mdc.type === 'PRC' || mdc.type=== 'PRC_DELIPOP'
              "
              link
              variant="primary"
              class="u-text-left"
              @click="toggleWithdrawalPoints(mdc.services)"
            >
              Voir la liste des points de retrait
            </Button>
            <Button
              v-if="
                mdc.type === 'CEV'
              "
              link
              variant="primary"
              class="u-text-left"
              @click="toggleWithdrawalPoints(mdc.services)"
            >
              Voir les adresses Drive piéton
            </Button>
            <Button
              v-if="mdc.type === 'CC'"
              link
              variant="primary"
              class="u-text-left"
              @click="togglePlanningTabClickCollect()"
            >
              En savoir plus sur le Click & Collect
            </Button>
            <template v-if="mdc.type === 'CC_TRAITEUR_PERMANENT'">
              <Button
                link
                variant="primary"
                class="u-text-left"
                @click="togglePlanningTabClickCollectTraiteur()"
              >
                <p>En savoir plus sur le Click & Collect Traiteur</p>
              </Button>
              <Button
                link
                variant="primary"
                align="left"
                class="u-mt-xxs"
                @click="$refs.traiteurPermanent.show()"
              >
                Voir l’emplacement du stand Traiteur
              </Button>
            </template>
            <template v-if="mdc.type === 'CC_TRAITEUR_NOEL'">
              <Button
                link
                variant="primary"
                class="u-text-left"
                @click="togglePlanningTabClickCollectTraiteurNoel()"
              >
                <p>En savoir plus sur le Click & Collect Traiteur</p>
              </Button>
              <Button
                link
                variant="primary"
                align="left"
                class="u-mt-xxs"
                @click="$refs.traiteurFete.show()"
              >
                Voir l’emplacement du stand Traiteur de Fêtes
              </Button>
            </template>
          </div>
        </div>
      </div>
    </Popin>

    <TemplateMagasin
      :is-pro="isPro"
      :is-national="isNational"
      :magasin="magasin"
      :attached-shop-id="attachedShopId"
      :push-zones="pushZones"
      @openOrcloseStoreLocator="$emit('openOrcloseStoreLocator')"
      @changeShop="(storeId) => changeShop(storeId)"
    >
      <div class="u-bgcolor-white u-mb-md u-p-sm">
        <Map
          style="height: 150px;"
          :positions="positions"
          :has-marker="false"
          class="u-mt-md"
        />
        <p class="u-mt-sm u-mb-xs u-font-15">
          {{ magasin.attributes.adresse }} <br />
          {{ magasin.attributes.cp }} {{ magasin.attributes.ville }}
        </p>
        <ButtonIcon
          link
          variant="primary"
          icon-name="map"
          icon-color="primary"
          :href="itineraire"
          target="__blank"
        >
          Itinéraire
        </ButtonIcon>
        <div
          v-if="
            (shopTimetable &&
              shopTimetable.timetable &&
              shopTimetable.timetable.length > 0) ||
              (exceptionalOpening && exceptionalOpening.length > 0) ||
              (exceptionalClosure && exceptionalClosure.length > 0)
          "
          class="u-mt-md u-mb-md"
        >
          <Divider dotted />
        </div>
        <template v-if="shopTimetable && shopTimetable.timetable && shopTimetable.timetable.length > 0">
          <p class="u-mb-xs u-font-15">
            <strong class="u-font-500">Horaires</strong>
          </p>
          <Button
            link
            variant="primary"
            class="u-mb-md"
            @click="$refs.horaires.show()"
          >
            Voir tous les horaires
          </Button>
        </template>
        <template v-if="exceptionalOpening && exceptionalOpening.length > 0">
          <p class="u-font-15 u-mb-xs">
            <strong class="u-font-500 ">Ouvertures exceptionnelles</strong>
          </p>
          <p
            v-for="(item, index) in exceptionalOpening"
            :key="item.type + index"
            class="u-color-success u-font-15 u-mb-xxs"
          >
            {{ uppercaseFirstLetter(item.date) }} de {{ item.from }} à
            {{ item.to }}
          </p>
        </template>
        <template v-if="exceptionalClosure && exceptionalClosure.length > 0">
          <p class="u-font-15 u-font-500 u-mb-xs">
            <strong class="u-font-500 ">Fermetures exceptionnelles</strong>
          </p>
          <p
            v-for="(item, index) in exceptionalClosure"
            :key="item.type + index"
            class="u-color-alert u-font-15 u-mb-xxs"
          >
            {{ uppercaseFirstLetter(item.date) }}
          </p>
        </template>
        <div class="u-mt-md u-mb-md">
          <Divider dotted />
        </div>
        <Button
          link
          variant="primary"
          class="u-mb-xs"
          @click="$refs.infos.show()"
        >
          Infos pratiques et services
        </Button>
      </div>
    </TemplateMagasin>

    <div
      v-if="
        magasin.attributes.modes_commande &&
          magasin.attributes.modes_commande.length > 0
      "
      class="u-bgcolor-white u-pl-sm u-pt-sm u-pr-sm u-pb-xlg u-text-center"
    >
      <!-- <div class="u-text-center">
        <TitleImage
          radius="full"
          :border="true"
          :action="false"
          image-path="https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs2/112692698/original/31a5d2469689575beee06ffcf4e9e76abab3abe2/logo-design-for-profile-picture-dessin-pour-photo-de-profil.png"
          image-alt="producteur"
          class="u-mt-md u-mx-auto u-flex u-flex-align-center"
        />
      </div>
      <Alert class="u-ml-sm u-mr-sm u-mb-md">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
      </Alert>
      <Divider dotted />-->
      <div
        v-if="
          magasin.attributes.modes_commande &&
            magasin.attributes.modes_commande.length > 0 &&
            !isPro
        "
        class="u-text-center u-mt-md u-ml-md u-mr-md"
      >
        <Titre
          tag="h2"
          size="xs"
          class="u-mb-xs"
        >
          Modes de livraison disponibles dans le magasin
          {{ magasin.attributes.magasin }}
        </Titre>
        <Button
          link
          variant="primary"
          @click="$refs.modesLivraison.show()"
        >
          Voir les modes de livraison disponibles
        </Button>
      </div>
    </div>
    <div class="u-pt-md u-pb-xlg u-bgcolor-white">
      <Divider />
      <div class="u-pt-lg u-px-sm">
        <MeaCoraproMagasin
          :magasin="magasin"
          is-fiche-magasin
        />
      </div>
    </div>
    <client-only>
      <ContainerHeading
        v-if="
          getPushData(ShopPageCodes.MOBILE_FM_MEA_1).html_content ||
            getPushData(ShopPageCodes.MOBILE_FM_MEA_1, 2).html_content ||
            getPushData(ShopPageCodes.MOBILE_FM_MEA_1, 3).html_content
        "
        :img-path="illustrationAnanasPastequePain"
        dotted
      >
        <div class="u-ml-xxlg u-mr-xxlg u-ml-none@md u-mr-none@md">
          <GridRow class="u-mb-sm">
            <GridCol
              v-if="getPushData(ShopPageCodes.MOBILE_FM_MEA_1).html_content"
              cols="6"
              sm="12"
              class="u-mb-md@sm"
            >
              <HtmlParser
                :context="
                  `FM  MEA 1: ${getPushTitle(ShopPageCodes.MOBILE_FM_MEA_1)}`
                "
                :promo-printing="true"
                :push-data="getPushData(ShopPageCodes.MOBILE_FM_MEA_1)"
              />
            </GridCol>
            <GridCol
              v-if="getPushData(ShopPageCodes.MOBILE_FM_MEA_1, 2).html_content"
              cols="6"
              sm="12"
              class="u-mb-md@sm"
            >
              <HtmlParser
                :context="
                  `FM MEA 2: ${getPushTitle(ShopPageCodes.MOBILE_FM_MEA_1)}`
                "
                :promo-printing="true"
                :push-data="getPushData(ShopPageCodes.MOBILE_FM_MEA_1, 2)"
              />
            </GridCol>
            <GridCol
              v-if="getPushData(ShopPageCodes.MOBILE_FM_MEA_1, 3).html_content"
              cols="6"
              sm="12"
            >
              <HtmlParser
                :context="
                  `FM MEA 3: ${getPushTitle(ShopPageCodes.MOBILE_FM_MEA_1)}`
                "
                :promo-printing="true"
                :push-data="getPushData(ShopPageCodes.MOBILE_FM_MEA_1, 3)"
              />
            </GridCol>
          </GridRow>
        </div>
      </ContainerHeading>
    </client-only>

    <ContainerHeading
      v-if="prospectus && prospectus.length > 0"
      :img-path="fruits"
      dotted
      class="u-text-center"
    >
      <Titre
        tag="h2"
        variant="primary"
        size="md"
        class="u-mb-md"
      >
        Faites des économies en consultant les prospectus
      </Titre>
      <div class="u-flex u-flex-justify-center u-mb-md">
        <template
          v-for="(item, index) in prospectus"
          :key="item.id"
        >
          <Prospectus
            v-if="index < 2"
            :img-path="item.attributes.cover"
            :period="item.attributes.period"
            :title="item.attributes.title"
            :link="item.attributes.url"
            :start-date="item.attributes.start_at"
            :page-type="trackingCodes.PAGETYPE.ficheMagasin"
            img-width="146"
            light
            class="u-ml-sm u-mr-sm u-mb-md"
          />
        </template>
      </div>
      <Button
        variant="primary"
        to="/prospectus"
        link
      >
        Voir tous les prospectus
      </Button>
    </ContainerHeading>

    <div class="u-bgcolor-white">
      <Divider class="u-m-none" />
    </div>

    <div
      v-if="fuel && fuel.length > 0"
      class="u-bgcolor-white u-p-sm u-text-center"
    >
      <Titre
        variant="primary"
        tag="h2"
        class="u-text-center u-mt-md"
      >
        Prix des carburants
      </Titre>

      <div class="u-flex u-flex-wrap u-flex-justify-center u-mb-md c-prix-carburant-container">
        <template
          v-for="fuelItem in fuel"
          :key="fuelItem.id"
        >
          <PrixCarburant
            :type="fuelItem.attributes.libelle"
            :name="fuelItem.attributes.libelle"
            :price="fuelItem.attributes.prix"
            class="u-m-xs"
          />
        </template>
      </div>
      <p
        v-if="isFuelAvailable"
        class="u-text-center u-font-15 u-mb-lg"
      >
        Pompes automatiques 24h/24 (hors fioul, commandable auprès du Village des Services).
      </p>
      <p
        v-else
        class="u-text-center u-font-15 u-mb-lg"
      >
        Pompes automatiques 24h/24
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-prix-carburant-container {
  max-width: 90rem;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2.4rem;
}
</style>
